import { CourseRulesInterface } from '../../..';
import { CourseClothingRestrictionDto } from './course-clothing-restriction.dto';
import { CourseParticipantGenderRestrictionDto, CourseParticipantRestrictionDto } from './course-participant-restriction.dto';

export class CourseRulesRequestDto implements CourseRulesInterface {
  participantRestriction?: CourseParticipantRestrictionDto;
  clothingRestriction?: CourseClothingRestrictionDto;
  isCheckInActive: boolean;
}
